var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useContext } from 'react';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import Snackbar from '@mui/material/Snackbar';
import SvgIcon from '@mui/material/SvgIcon';
import { updateUserSettings } from '../api';
import ApiContext from '../contexts/apiContext';
import UserContext from '../contexts/userContext';
import getBrowserLocale from '../helpers/getBrowserLocale';
import UKFlag from './svg/UKFlag';
import USFlag from './svg/USFlag';
var LanguageSelector = function () {
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var _a = useContext(UserContext), userSettings = _a.userSettings, setUserSettings = _a.setUserSettings;
    var _b = useState((userSettings === null || userSettings === void 0 ? void 0 : userSettings.locale) || getBrowserLocale()), locale = _b[0], setLocale = _b[1];
    var _c = useState(false), snackbarOpen = _c[0], setSnackbarOpen = _c[1];
    var handleLocaleChange = function (_, newLocale) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLocale(newLocale);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateUserSettings(apiBaseUrl, { locale: newLocale })];
                case 2:
                    _a.sent();
                    setUserSettings(userSettings ? __assign(__assign({}, userSettings), { locale: newLocale }) : { locale: newLocale });
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSnackbarClose = function (_, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(ToggleButtonGroup, { value: locale, exclusive: true, onChange: handleLocaleChange, children: [_jsx(ToggleButton, { value: "en-GB", children: _jsx(SvgIcon, { children: _jsx(UKFlag, {}) }) }), _jsx(ToggleButton, { value: "en-US", children: _jsx(SvgIcon, { children: _jsx(USFlag, {}) }) })] }), _jsx(Snackbar, { anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, open: snackbarOpen, autoHideDuration: 6000, onClose: handleSnackbarClose, message: "Your language preferences have been saved; existing chats won't be affected by this change" })] }));
};
export default LanguageSelector;
